import React from "react";

import {
    Wallet,
    Package,
     Clock3,
    Bike,
} from "lucide-react";

import "./EarningsSummary.css";

function EarningsSummary({ dashboard }) {

   const cards = [

    {
        title: "Today's Earnings",
        value: `₹${dashboard?.todayEarnings || 0}`,
        icon: <Wallet size={26} />,
        color: "green",
    },

    {
        title: "Today's Orders",
        value: dashboard?.todayOrders || 0,
        icon: <Package size={26} />,
        color: "orange",
    },

    {
        title: "Total Earnings",
        value: `₹${dashboard?.totalEarnings || 0}`,
        icon: <Clock3 size={26} />,
        color: "blue",
    },

    {
        title: "Total Distance",
        value: `${dashboard?.totalDistance || 0} km`,
        icon: <Bike size={26} />,
        color: "purple",
    },

];
    return (

        <div className="earnings-summary">

            {

                cards.map((card, index) => (

                    <div
                        key={index}
                        className="earning-card"
                    >

                        <div
                            className={`earning-icon ${card.color}`}
                        >

                            {card.icon}

                        </div>

                        <div className="earning-content">

                            <p>

                                {card.title}

                            </p>

                            <h2>

                                {card.value}

                            </h2>

                        </div>

                    </div>

                ))

            }

        </div>

    );

}

export default EarningsSummary;